<template>
    <div id='Notifications' class='col-2 col-md-1 text-center' :class="{'WithPending': numberOfCuurentPendingNotifications > 0}">
        <div class='row'>
            <div class='PendingNotifications col-12' v-if="numberOfCuurentPendingNotifications > 0 && currentModule == 'PowerScan'">
                <span id='PendingNotificationIndicator' v-if="numberOfCuurentPendingNotifications > 0">{{numberOfCuurentPendingNotifications}}</span>
                <span id='PendingNotificationToggle' @click='togglePendingNotificationScreen'>
                    <PendingNotificationIcon />
                </span>
            </div>
            <div v-if="numberOfCuurentPendingNotifications == 0" class='Notifications col-12' :class="{'col-sm-6': numberOfCuurentPendingNotifications > 0}">
                <span id='NotificationIndicator' v-if="numberOfCuurentNotifications > 0">{{numberOfCuurentNotifications}}</span>
                <span id='NotificationToggle' @click='toggleNotificationScreen'>
                    <NotificationIcon />
                </span>
            </div>
        </div>
        <div id='NotificationSection' v-if="currentModule != 'PowerScan'">
            <NotificationList v-if='NotificationsOpened && numberOfCuurentNotifications > 0' :notifications='this.currentNotifications'></NotificationList>
            <ToastList />
        </div>
        <div id='PendingNotifications' v-if="currentModule == 'PowerScan'">
            <PendingNotificationList v-if='PendingNotificationsOpened && numberOfCuurentPendingNotifications > 0' :notifications='this.currentPendingNotifications' @re-enable-scroll='reEnableScroll'></PendingNotificationList>
        </div>
        <div id='PsNotifications' v-if="currentModule == 'PowerScan'">
            <PsNotificationList v-if='NotificationsOpened && numberOfCuurentNotifications > 0' :notifications='this.currentNotifications' @re-enable-scroll='reEnableScroll'></PsNotificationList>
            <ToastList />
        </div>
    </div>

</template>
<script>
    import NotificationIcon from '../../../icons/NotificationIcon.vue'
    import PendingNotificationIcon from '../../../icons/PendingNotificationIcon.vue'
    import NotificationList from './NotificationList.vue'
    import PsNotificationList from './PsNotificationList.vue'
    import PendingNotificationList from './PendingNotificationList.vue'
    import ToastList from './ToastList'
    export default{
        name: 'Notifications',
        components: {
            NotificationIcon,
            PendingNotificationIcon,
            NotificationList,
            PsNotificationList,
            PendingNotificationList,
            ToastList
        },
        data(){
            return{
                NotificationsOpened: false,
                PendingNotificationsOpened: false
            }
        },
        computed: {
            currentNotifications(){
                return this.$store.getters['ProductCollection/notificationCollection']
            },
            currentPendingNotifications(){
                return this.$store.getters['ProductCollection/pendingNotificationCollection']
            },
            currentModule(){
                return this.$route.meta.activeModule;
            },
            numberOfCuurentNotifications(){
                return this.currentNotifications.length;
            },
            numberOfCuurentPendingNotifications(){
                return this.currentPendingNotifications.length;
            },
        },
        methods:{
            toggleNotificationScreen(){
                let bodyTag = document.body;
                if (this.NotificationsOpened){
                    this.NotificationsOpened = false;
                        if(this.PendingNotificationsOpened == false){
                            bodyTag.style.overflow = 'auto'
                        }
                }else{
                    this.NotificationsOpened = true;
                    bodyTag.style.overflow = 'hidden'
                }
            },
            togglePendingNotificationScreen(){
                let bodyTag = document.body;
                if (this.PendingNotificationsOpened){
                    this.PendingNotificationsOpened = false;
                        if(this.NotificationsOpened == false){
                            bodyTag.style.overflow = 'auto'
                        }
                }else{
                    this.PendingNotificationsOpened = true;
                    bodyTag.style.overflow = 'hidden'
                }
            },
            reEnableScroll(){
                this.NotificationsOpened = false;
                this.PendingNotificationsOpened = false;
                document.body.style.overflow = 'auto'
            }
        }
    }
</script>